<script>
import moment from 'moment-timezone'
import Parse from 'parse'
import Color from '@/components/Color'
import * as UTILS from '@/components/utils.js'
import EventBus from '@/EventBus'
import Constants from '@/components/Constants'
import { getWeekStartFromDate, getNextWeekStartFromDate } from '../../clavo-shared/functions/time'

export default {
  mixins: [Color, Constants],
  data() {
    return {
      avatarUrl: null,
      userColor: null,
      userStartOfWeek: null,
    }
  },
  computed: {
    user() {
      return Parse.User.current()
    },
    userId() {
      return !this.user || this.user._getId()
    },
    username() {
      return !this.user || Parse.User.current().getUsername()
    },
    fullname() {
      return !this.user || Parse.User.current().attributes.fullName
    },
  },
  created() {
    let avatar = this.user.get('avatar')
    if (avatar) this.avatarUrl = this.user.get('avatar').url()
    else if(this.user.attributes.avatarIndex){
      this.avatarUrl = require('@/assets/avatars/' + this.avatars()[this.user.attributes.avatarIndex])
    } else {
      this.avatarUrl = require('@/assets/avatars/' + this.avatars()[0])
    }
    this.userColor = avatar ? '' : this.user.get('color')
    const userSettings = this.$store.state.userSettings
    this.userStartOfWeek = userSettings['week-start'] ? userSettings['week-start'] : 'Monday'
  },
  methods: {
    async saveAvatar(base64) {
      this.user.set('avatar', new Parse.File('avatar', { base64: base64 }))
      try{
        await this.user.save()
        this.avatarUrl = base64
        EventBus.$emit('avatar-changed', base64)
      }catch (e){
        if (e.message === 'request entity too large'){
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('fileToolLarge'),
            error: true,
          })
        }else{
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('avatarNotChanged'),
            error: true,
          })
        }
      }
      this.$store.commit('setShowProgressBar', false)

    },
    // async resetAvatar() {
    //   let uri = this.randomAvatar()
    //   let color = this.randomColor()
    //   this.user.set('avatar', new Parse.File('default', { uri: uri }))
    //   this.user.set('color', color)
    //   await this.user.save()
    //   this.avatarUrl = uri
    //   this.userColor = color
    // },
    uploadAvatar(e) {
      // console.log('uploading avatar', e)
      var files = e.target.files || e.dataTransfer.files
      if (files.length) {
        var reader = new FileReader()
        reader.onload = e => {
          this.$store.commit('setShowProgressBar', true)
          this.saveAvatar(e.target.result)
        }
        reader.readAsDataURL(files[0])
        // console.log('filex', files)
      }
    },
    randomAvatar() {
      let avatars = require.context('@/assets/avatars', false, /^.*\.svg$/)
      let key = avatars.keys()[Math.floor(avatars.keys().length * Math.random())]
      return avatars(key)
    },
    sliceByDays(entries, workOnly = false) {
      // slice multi-day (or overlapping) entries
      // so that entries start and end the same day (min: 0:00, max 23:59)
      // #TODO? pershaps this should be done on the server-side?
      let output = []
      this.scheduledMinutes = 0 // TODO? (mixed logic) should not be here
      entries.forEach(function(entry) {
        if (entry.type == 'work' || !workOnly)
          for (let day = moment(entry.start).startOf('day'); day < moment(entry.end); day.add(1, 'days')) {
            let start = moment.max(moment(entry.start), day)
            let end = moment.min(moment(entry.end), moment(day).endOf('day'))
            let duration = moment(entry.end).diff(entry.start, 'minutes')
            this.scheduledMinutes += duration
            output.push({
              id: entry.id + '__' + day.format('L'),
              start: start.toDate(),
              end: end.toDate(),
              duration: duration,
              type: entry.type,
              location: entry.location,
            })
          }
        else output.push(entry)
      }, this)
      return output
    },
    sliceByWeeks(entries) {
      let output = []
      entries.forEach(function(entry) {
        for (let day = getWeekStartFromDate(entry.start, this.userStartOfWeek, this.user.get('timezone')); day < moment(entry.end); day.add(1, 'weeks')) {
          let start = moment.max(moment(entry.start), day)
          let end = moment.min( moment(entry.end), getNextWeekStartFromDate(day, this.userStartOfWeek, this.user.get('timezone')))
          let duration = moment(entry.end).diff(entry.start, 'minutes')

          output.push({
            id: entry.id + '__week_' + day.format('L'),
            start: start.toDate(),
            end: end.toDate(),
            duration: duration,
            type: entry.type,
            location: entry.location,
          })
        }
      }, this)
      return output
    },
  },
}
</script>
